import Instance from "../../../../Axios";

// New Actions for the app

const GetCredVeiculos = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/veiculos`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_VEICULOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredVeiculos;
